import React from 'react';
import Select, { selectType } from 'Components/Select';
import YearPicker from '../../../Components/YearPicker';
import RowsSelector from 'Components/RowsSelector';

const statuses = ['All', 'Approved', 'Incomplete', 'Deactivated'];

export default function Filters({
  outCount,
  handleRowsSelect,
  rowsCount,
  handleSelectFilter,
  filterState,
  currentModelYear,
}) {
  return (
    <section className='list-scene__utility-section-wrapper'>
      <section className='list-scene__utility-section-filters-wrapper'>
        <div className='list-scene__utility-section-filters-header'>Filter</div>
        <Select
          label='By Status'
          placeholder='All'
          withoutSearch
          defaultItem={filterState.status}
          selectionList={statuses}
          handleSelect={handleSelectFilter('status')}
          type={selectType.listFilter}
        />
        <YearPicker
          endYear={currentModelYear + 1}
          yearPickAction={handleSelectFilter('year')}
          year={filterState.year}
          width={160}
          height={18}
        />
      </section>

      <section className='list-scene__utility-section-rows-select-wrapper'>
        <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowsSelect} selectedRowsCount={rowsCount} />
      </section>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/TrailerManufacturer/List/FiltersSection.jsx